<script>
import { mapState } from 'vuex'
import { pick } from 'lodash-es'

export default {
    data() {
        return {
            isOpen: false
        }
    },

    computed: {
        ...mapState('cart', [
            'items',
            'discounts',
            'price'
        ]),
    },

    created() {
        this.$bus.$on('cart-widget-toggled', () => {
            this.isOpen = ! this.isOpen })
    },

    render() {
        return this.$scopedSlots.default(
            pick(this, 'items', 'discounts', 'price', 'isOpen')
        )
    }
}
</script>
